import {
  AttorneyApprovalStatus,
} from "../../../../../api";
import { ApplicationRole } from "../../../../../api/models/ApplicationRole";
import { LeadViewModel } from "../../../../../api/models/LeadViewModel";
import { LeadType } from "../../shared/Constants";
import KeepProcessActions from "./KeepProcessActions";
import ReferralProcessActions from "./ReferralProcessActions";

interface AdminActionsProps {
  leadType: LeadType;
  userRoles?: ApplicationRole[];
  details?: LeadViewModel;
}

export default function AdminActions(props: AdminActionsProps) {
  const showKeep =
    props.leadType === LeadType.Admin &&
    props.details?.attorneyApprovalStatus === AttorneyApprovalStatus.KEEP;
  const showRefer =
    props.details?.attorneyApprovalStatus === AttorneyApprovalStatus.REFER;

  if (!showKeep && !showRefer) {
    return null;
  }

  // Keep/refer action forms render into the lead details right-hand side rail.
  return (
    <>
      {showKeep && (
        <KeepProcessActions
          details={props.details}
          userRoles={props.userRoles}
        />
      )}
      {showRefer && (
        <ReferralProcessActions
          leadType={props.leadType}
          userRoles={props.userRoles}
          details={props.details}
        />
      )}
    </>
  );
}
